export default __webpack_public_path__ + "static/media/menuL_icon_03.2c2676de.png";